import { useCallback } from 'react';
import { useRegisterContext } from '../reducer/useRegister';
import { requestRegistrationCode } from '../../rest-api/request';
import { isAllowedToResendOtp } from '../../common/otpAbuseHelper';

export const useResendRegistrationCode = () => {
  const [state, dispatch] = useRegisterContext();
  return useCallback(async () => {
    const data = state.data;
    if (data.type !== 'CREATE_ACCOUNT' || state.loading) {
      return;
    }
    dispatch('LOADING');
    const { phoneNumber, zipCode } = data;
    if (isAllowedToResendOtp()) {
      try {
        const response = await requestRegistrationCode(phoneNumber, zipCode);
        dispatch({
          type: 'CREATE_ACCOUNT',
          phoneNumber,
          zipCode,
          sfContactId: response.sf_contact_id,
          agreementTime: data.agreementTime,
        });
      } catch (error) {
        dispatch({ ...data, error: 'generic-error' });
      }
    } else {
      dispatch({ ...data, error: 'rate-limited' });
    }
  }, [state, dispatch]);
};
